import { motion } from "framer-motion";
import { fadeUp } from "@/lib/motion";

export default function BusinessTypes({ types = [] }) {
  return (
    <section id="business-types" data-testid="business-types-section" className="relative bg-white py-24 border-b border-slate-100 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <motion.div {...fadeUp} className="lg:col-span-6">
            <span className="eyebrow">Who we build for</span>
            <h2 className="mt-4 font-display font-bold text-navy tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.05]">
              Built for the businesses that keep the world running.
            </h2>
          </motion.div>
          <motion.p {...fadeUp} className="lg:col-span-6 text-lg text-slate-600 leading-relaxed">
            Whether you run a storefront, a service, a fleet or a growing startup, we build the tech and content around the way you already work.
          </motion.p>
        </div>

        <div className="mt-14 flex flex-wrap gap-3">
          {types.map((t, i) => (
            <motion.span
              key={t}
              data-testid={`business-type-${i}`}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.4, delay: i * 0.04 }}
              className="group inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-5 py-3 text-sm font-medium text-slate-700 hover:border-brand-blue hover:bg-navy hover:text-white transition-all cursor-default"
            >
              <span className="h-1.5 w-1.5 rounded-full bg-brand-blue group-hover:bg-brand-cyan transition-colors" />
              {t}
            </motion.span>
          ))}
          <span className="inline-flex items-center rounded-full px-5 py-3 text-sm font-medium text-slate-400 italic">
            …and many more.
          </span>
        </div>
      </div>
    </section>
  );
}
